import { useLocale } from "features/i18n/useLocale";

export function Percentage({ children }: { children: number }) {
    const locale = useLocale();
    return (
        <span>
            {new Intl.NumberFormat(locale, {
                style: "percent",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(children)}
        </span>
    );
}

export function Decimal({
    children,
    maxDigits = 2,
}: {
    children: number;
    maxDigits?: number;
}) {
    const locale = useLocale();
    return (
        <span data-testid="scaling">
            {new Intl.NumberFormat(locale, {
                maximumFractionDigits: maxDigits,
            }).format(children)}
        </span>
    );
}
